import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { AuthenticationService } from '../security/authentication.service';

@Component({
  selector: 'dofbasen-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  constructor(private router: Router, public authenticationService : AuthenticationService) {}
  
  logout() : void {
    localStorage.removeItem('ls.userInfo');
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/app/share/header/header.component.ts